import React from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

import { HR, Flex } from 'ui/acro'

import Hero from './Hero'
import Categories from './Categories'
import Instructors from './Instructors'
//import Awards from './Awards'
import Devices from './Devices'
import Stories from './Stories'

import { unlock_membership_event } from 'gtm/pushEvents'
import TrialConnectHub from './TrialConnectHub'

import HeroBillBoard from './HeroBillBoard'
import BottomBillBoard from './BottomBillBoard'
import PartnershipOffer from './PartnershipOffer'

import { Builder, BuilderComponent, builder } from '@builder.io/react'

// Determine the API key based on the URL
const builderPublicApiKey =
  window.location.hostname === 'www.alomoves.com'
    ? '7ae91e2100c441348821b5902d6e5194'
    : '61e2402350ce4c0cbc02c5526b936de4'

// Init builder.io with the appropriate key
builder.init(builderPublicApiKey)

const Home = ({ heroVideos, heroHeader, banner, trialBanner }) => {
  // if this localStorage value exists, that means the user has an account and has dismissed the HP survey prompt, remove this to show it again upon next login
  // if (localStorage.dismissedNotif) {
  //   localStorage.removeItem('dismissedNotif')
  // }
  return (
    <Flex flexDirection='column' id='home-signed-out'>
      {/* <Hero videos={heroVideos} {...heroHeader} /> */}
      <HeroBillBoard />
      <HR my='32px' display={['block', null, 'none']} />

      <LazyLoad offset={250}>
        <Categories mt={['0px', null, '50px']} />
      </LazyLoad>

      <LazyLoad offset={250}>
        <Instructors mt={['48px', null, null, '150px']} />
      </LazyLoad>

      <LazyLoad offset={250}>
        <Devices mt={['48px', null, null, '150px']} />
        <HR my='32px' display={['block', null, 'none']} />
      </LazyLoad>
      {/* we do not have permission to use those names and logos and we need to remove them for now */}
      {/* <LazyLoad offset={250}>
        <Awards mt={['48px', null, null, '150px']} />
      </LazyLoad> */}

      <LazyLoad offset={250}>
        <PartnershipOffer mt={['48px', null, '150px']} />
      </LazyLoad>

      <LazyLoad offset={250}>
        <Stories mt={['48px', null, '150px']} />
      </LazyLoad>

      <LazyLoad offset={250}>
        {/* <TrialConnectHub
          title={
            trialBanner && trialBanner.title ? trialBanner.title : banner.title
          }
          body={
            trialBanner && trialBanner.body ? trialBanner.body : banner.body
          }
          cta={trialBanner && trialBanner.cta ? trialBanner.cta : banner.cta}
          id='start_free_trial_section'
          mt={['65px', null, '150px']}
          onClickBtn1={() => unlock_membership_event('homepage_bottom')}
        /> */}
        <BottomBillBoard mt={['48px', null, '150px']} />
      </LazyLoad>
    </Flex>
  )
}

Home.propTypes = {
  heroVideos: PropTypes.object,
  heroHeader: PropTypes.object,
  banner: PropTypes.object,
  trialBanner: PropTypes.object
}

export default Home
